import { render, staticRenderFns } from "./MaternityEdit.vue?vue&type=template&id=9bfbbfe8"
import script from "./MaternityEdit.vue?vue&type=script&lang=js"
export * from "./MaternityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports